export class IPostCounteryBodyDto {
  name: string;
  code: string;
}

import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class Countery {
  id: string | number;
  name: string;
  code: string;
}

export class ICounteryResponse {
  @Type(() => Countery)
  result: Countery;
}

export class ICounteryListResponse extends IPagination {
  @Type(() => Countery)
  results: Countery[];
}

export class ICounteryQueryDto extends IQueryPaginationDto {
  name?: string;
  code?: string;
}

export class ICounteryPatchBodyDto {
  name?: string;
  code?: string;
}
